export default __webpack_public_path__ + "static/media/left_character.686a8340.png";